'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _formatCurrency = require('../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _beautifyNumber = require('./beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var displayPrice = function displayPrice(properties, styles, isProject) {var _cx;var
  isRtl = properties.isRtl,searchOption = properties.searchOption,translate = properties.translate,images = properties.images;
  var isEmptyPrice = properties.isDynamic && !properties.price;
  var beautifiedPrice = isEmptyPrice ? _react2.default.createElement('span', { className: styles.emptyPrice }) : (0, _beautifyNumber2.default)(properties.price);
  var currencyIcon = properties.currency ? (0, _formatCurrency2.default)(properties.currency) : '₪';var
  currency =
  _react2.default.createElement('i', { className: styles.currency }, !properties.withoutCurrency && currencyIcon),price = beautifiedPrice;
  if (isRtl) {var _ref =
    [price, currency];currency = _ref[0];price = _ref[1];
  }

  if (searchOption === 'rent-short') {
    return (
      isRtl ?
      _react2.default.createElement('span', { className: styles.propertyPrice },
        currency, ' ', price, '/', translate('propertyDetails', 'day')) :

      _react2.default.createElement('span', { className: styles.propertyPrice },
        translate('propertyDetails', 'day'), '/', currency, ' ', price));


  } else if (isProject) {
    return (
      _react2.default.createElement('span', { className: styles.propertyPrice },
        translate('from'), ' ', currency, ' ', price));


  }
  return (
    _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.propertyPrice, (_cx = {}, _cx[styles.movePrice] = images && images.length > 1, _cx)) },
      currency, ' ', price));


};exports.default =

displayPrice;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/displayPrice.js
// module id = 389
// module chunks = 0